export function identity<T>(x: T): T {
  return x;
}



// WEBPACK FOOTER //
// ../../../../node_modules/src/util/identity.ts